module.exports = __webpack_public_path__ + "overview-a5b6df21/website-2142863eea0f6948afb1bb3add461d4c.svg";